import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

// Importaciones de servicios.
import { LogService } from '../../services/log.service';

/**
 * Componente de diálogo para la eliminación de todos los registros.
 *
 * Este componente proporciona una interfaz para confirmar y realizar la eliminación de los registros.
 * Se muestra como un cuadro de diálogo, permitiendo al usuario confirmar la acción antes de proceder con la eliminación.
 */
@Component({
  selector: 'app-log-delete-all-dialog',
  templateUrl: './log-delete-all-dialog.component.html',
  standalone: false,
})
export class LogDeleteAllDialogComponent {
  /**
   * Referencia al diálogo actual.
   *
   * Se utiliza para controlar y cerrar el cuadro de diálogo de eliminación de los registros.
   */
  readonly dialogRef: MatDialogRef<LogDeleteAllDialogComponent> = inject(
    MatDialogRef<LogDeleteAllDialogComponent>
  );

  /**
   * Indica si la operación de eliminado está en curso.
   *
   * Se utiliza para deshabilitar la interfaz y mostrar un indicador de carga mientras se elimina los registros.
   */
  loading: boolean = false;

  /**
   * Lista de errores.
   *
   * Contiene los mensajes de error generados si la operación de eliminado falla.
   */
  errors: string[] = [];

  /**
   * Constructor del componente.
   *
   * Este constructor inyecta las dependencias necesarias para el funcionamiento del componente.
   *
   * @param logService - Servicio para gestionar los registros.
   * @param snackBar - Servicio para mostrar notificaciones de tipo snack bar.
   */
  constructor(private logService: LogService, private snackBar: MatSnackBar) {}

  /**
   * Confirma y elimina todos los registros.
   *
   * Muestra un diálogo de confirmación antes de proceder con la eliminación.
   * Si la eliminación es exitosa, cierra el diálogo.
   */
  async deleteAll(): Promise<void> {
    this.loading = true;
    this.errors = [];

    try {
      const response = await this.logService.deleteAll();

      this.snackBar.open(response, '', { duration: 5000 });

      this.dialogRef.close(true);
    } catch (errors: any) {
      this.errors = errors;
    }

    this.loading = false;
  }
}
